// ສະຖານະຄຳຮ້ອງຍົກຍ້າຍໂຮງຮຽນຂອງນັກຮຽນ — ໃຊ້ຮ່ວມກັນລະຫວ່າງໜ້າສ້າງ, ລາຍຊື່, ແລະ ປະຫວັດ/ພິມ
export const TRANSFER_STATUS_LABELS = {
  Draft: 'ຮ່າງ (ຍັງບໍ່ໄດ້ສົ່ງ)',
  PendingHomePESS: 'ລໍຖ້າ ພສສ ຕົ້ນທາງ ກວດສອບ',
  PendingHostPESS: 'ລໍຖ້າ ພສສ ປາຍທາງ ອະນຸມັດ',
  PendingHostSchool: 'ລໍຖ້າໂຮງຮຽນປາຍທາງ ຮັບຮອງ',
  Accepted: 'ຍົກຍ້າຍສຳເລັດແລ້ວ',
  RejectedByHomePESS: 'ຖືກປະຕິເສດໂດຍ ພສສ ຕົ້ນທາງ',
  RejectedByHostPESS: 'ຖືກປະຕິເສດໂດຍ ພສສ ປາຍທາງ',
  RejectedByHostSchool: 'ຖືກປະຕິເສດໂດຍໂຮງຮຽນປາຍທາງ'
};

export function transferStatusLabel(value) {
  return TRANSFER_STATUS_LABELS[value] || value || '-';
}

export function transferStatusBadgeClass(value) {
  if (value === 'Accepted') return 'badge-success';
  if (value === 'Draft') return 'badge-neutral';
  if (typeof value === 'string' && value.startsWith('Rejected')) return 'badge-danger';
  return 'badge-warning';
}

export const ORG_ROLE_LABELS = {
  school: 'ໂຮງຮຽນ',
  desb: 'ຫ້ອງການສຶກສາ ແລະ ກິລາເມືອງ (DESB)',
  pess: 'ພະແນກສຶກສາ ແລະ ກິລາແຂວງ (PESS)'
};

export function orgRoleLabel(value) {
  return ORG_ROLE_LABELS[value] || 'ໂຮງຮຽນ';
}
